import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import TrustBar from "@/components/TrustBar";
import ServicesSection from "@/components/ServicesSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import CookieConsent from "@/components/CookieConsent";
const Index = () => {
  return (
    <main className="min-h-screen">
      <SEO 
        title="Koristusteenused ja kinnisvara haldus üle Eesti"
        description="LVK Haldus pakub professionaalseid koristusteenuseid ja haldusteenuseid üle Eesti. Hoolduskoristus, eripuhastus, haldusteenus ettevõtetele, korteriühistutele ja eraklientidele."
        keywords="koristusteenus, puhastusteenus, hoolduskoristus, eripuhastus, haldusteenus, kinnisvara haldus, Eesti, Tallinn, Tartu, Pärnu, Rakvere, koristus Tallinn, koristus Tartu, puhastusteenus Eesti"
      />
      <Navbar />
      <HeroSection />
      <TrustBar />
      <ServicesSection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <CookieConsent />
    </main>
  );
};

export default Index;
